// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "6362") return "js/2.0.49-production-master/app.6362.9d15b7d7e97030fc.chunk.js";
  // return url for filenames based on template
  return "" + chunkId + ".javascript"
}